import React from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { FlowList } from './components';
const FlowList = React.lazy(() => import(/* webpackChunkName: "FlowList" */'./components'));
const routes = () => (
  <PrivateRoute exact path="/settings/flow" component={FlowList} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/FlowList/routes.js